import React from "react";
import { flexRender, type HeaderGroup } from "@tanstack/react-table";

interface TableHeaderProps {
  headerGroups: HeaderGroup<Record<string, any>>[];
}

export const TableHeader: React.FC<TableHeaderProps> = ({ headerGroups }) => {
  return (
    <thead className="bg-primary-blue">
      {headerGroups.map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => (
            <th
              key={header.id}
              className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider cursor-pointer relative border-b-2 border-r-2 border-border-gray"
              style={{
                width: header.getSize(),
              }}
              onClick={header.column.getToggleSortingHandler()}
            >
              <div className="flex items-center justify-between">
                {header.isPlaceholder
                  ? null
                  : flexRender(header.column.columnDef.header, header.getContext())}
                {header.column.getIsSorted() && (
                  <span className="ml-2">{header.column.getIsSorted() === "desc" ? "↓" : "↑"}</span>
                )}
              </div>
              {header.column.getCanResize() && (
                <div
                  onMouseDown={(e) => {
                    e.stopPropagation();
                    header.getResizeHandler()(e);
                  }}
                  onTouchStart={(e) => {
                    e.stopPropagation();
                    header.getResizeHandler()(e);
                  }}
                  onClick={(e) => e.stopPropagation()}
                  className="absolute top-0 right-0 h-full w-1 bg-white cursor-col-resize opacity-60 hover:opacity-100 transition-opacity"
                  style={{
                    transform: header.column.getIsResizing() ? "scaleX(2)" : "scaleX(1)",
                  }}
                />
              )}
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );
};
